import { type FC } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';
import { useUserSelector } from '@/packages/redux-state/store/slices/user';

import { useCardOfferDataContext } from '../../context/selectors';

import { PromotionDescription } from './components/PromotionDescription';
import { usePromotionTitle, usePromotionTooltipItems } from './hooks';

export const PromotionDescriptionContainer: FC = () => {
  const {
    extendedProperties: { auction },
  } = useCardOfferDataContext();

  const isNarrow = useListingLayoutIsNarrowSelector();

  const vasList = usePromotionTooltipItems();

  const promotionTitle = usePromotionTitle();

  const { isBuilder, isAuthenticated, lkType } = useUserSelector();

  const isSearcher = !isAuthenticated || lkType === 'searcher';

  if (isSearcher || isBuilder || !promotionTitle) {
    return null;
  }

  return (
    <PromotionDescription
      isBet={!!auction}
      item={vasList}
      promotionDescription={promotionTitle}
      tooltipPosition={isNarrow ? 'top-start' : 'top-end'}
    />
  );
};
